import { render, staticRenderFns } from "./drawerDetail.vue?vue&type=template&id=60940cca&scoped=true"
import script from "./drawerDetail.vue?vue&type=script&lang=js"
export * from "./drawerDetail.vue?vue&type=script&lang=js"
import style0 from "./drawerDetail.vue?vue&type=style&index=0&id=60940cca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60940cca",
  null
  
)

export default component.exports